// utils/getStripePromise.js
import { loadStripe } from "@stripe/stripe-js";

const stripeCache = {};

export const getStripePromise = (locale) => {
  const publicKey = process.env.REACT_APP_STRIPE_PUBLIC_KEY;

  if (!publicKey) {
    throw new Error("Stripe public key not found in environment variables.");
  }

  if (!stripeCache[locale]) {
    stripeCache[locale] = loadStripe(publicKey, { locale });
  }

  return stripeCache[locale];
};
